import { useMutation, useQueryClient } from '@tanstack/react-query';

import { type UpdateMediaAssetBody, updateMediaAsset } from '~/services/MediaService';

import { mediaAssetQueryKeys } from './mediaQueryKeys';

/**
 * Saves changes to one media asset.
 *
 * Listings show the same figures as the asset itself, so they are refreshed alongside it.
 */
export function useUpdateMediaAsset(assetId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (body: UpdateMediaAssetBody) => updateMediaAsset(assetId, body),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: mediaAssetQueryKeys.all }),
  });
}
